<div class="custom-form-field" [ngClass]="{'display-inline':display_inline}">
  @if (title && !display_inline) {
    <h3>{{title}}</h3>
  }
  <div>
    <div class="row center full-width">
      @if (title && display_inline) {
        <label>{{title}}:</label>
      }
      @for (opt of getConfigurationOptions(); track opt) {
        @if (opt.field_type === 'input' || opt.field_type==='div') {
          <mat-form-field>
            <mat-label>{{opt.name | removeUnderscore | upperfirst}}</mat-label>
            <input matInput [type]="opt.type"
              [(ngModel)]="config[opt.name]"
              (ngModelChange)="configChanged.emit(config)"
              [disabled]="opt.field_type==='div'">
          </mat-form-field>
        }
        @if (opt.field_type === 'checkbox') {
          <mat-checkbox
            [(ngModel)]="config[opt.name]"
            (ngModelChange)="configChanged.emit(config)"
            class="form-element-align">
          {{opt.name | removeUnderscore | upperfirst}}</mat-checkbox>
        }
      }
    </div>
  </div>
